import type { DefaultUom } from "../api/types";

const eurFmt = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
});

export function formatInventoryUnitPrice(eur: string, uom: DefaultUom): string {
  const n = Number(eur);
  if (!Number.isFinite(n)) return "—";
  return `${eurFmt.format(n)} / ${uom}`;
}
